export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/UserCodeRuntime.worker.78c93826bf8476f6ca5c.worker.js");
}
